export const UPDATE_FILTERS = 'UPDATE_FILTERS';